import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/satoshi.css';
import './css/main.css';
import LookingGlass from "./looking-glass";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <LookingGlass />
  </React.StrictMode>
);